import hero from "./assets/hero.png"

export const sparkData = {
    title: "Working with a Sri Lankan Startup to Re-think Career-focused IT Education",
    heroImage: hero,
    thumbnailImage:hero,
}